import { Component, Version } from '@angular/core';
import { AppdataService } from '../../../service/appdata.service';
import { StreamService } from '../../../service/stream.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormBuilder, Validators } from '@angular/forms';
import { SnackService } from '../../../service/snack.service';
import { MatDialog } from '@angular/material/dialog';
import { EditStepComponent } from '../edit-step/edit-step.component';
import { PromptService } from '../../../service/prompt.service';



@Component({
  selector: 'app-edit-stream',
  standalone: false,
  templateUrl: './edit-stream.component.html',
  styleUrl: './edit-stream.component.scss'
})
export class EditStreamComponent {
  stream: any;
  track: any;
  agents: any[] = [];
  created: any
  updated: any;
  hidespinner: boolean = true;

  streamNameFormControl: any;
  streamRoleFormControl: any;
  streamToneFormControl: any;
  streameVersionFormControl: any;
  streamContextFormControl: any;

  streamPromptVersions: any[] = [];
  currentStreamPrompt: any;
  defaultAgentId: any;
  history: any[] = [];
  sessionHistory: any[] = [];
  sessionHistoryIndex: number = 0;
  outputControls: any[] = [];

  outputTypes: any[] = [
    { name: "PDF", value: "PDF" },
    { name: "Miro", value: "MIRO" },
    { name: "Text", value: "TEXT" },
  ]
  promptStati: any[] = [
    { name: "Active", value: "ACTIVE" },
    { name: "Inactive", value: "INACTIVE" }
  ]

  constructor(
    private appData: AppdataService,
    private streamService: StreamService,
    private promptService: PromptService,
    private fb: FormBuilder,
    private snack: SnackService,
    private dialog: MatDialog
  ) {
    this.appData.showHeaderBackButton.next(true);
    appData.showMenue.next(false)

    this.streamNameFormControl = this.fb.control('', Validators.required);
    this.streamRoleFormControl = this.fb.control('');
    this.streamToneFormControl = this.fb.control('');
    this.streameVersionFormControl = this.fb.control(0);
    this.streamContextFormControl = this.fb.control('');

    let streamId = window.location.href.split('/').pop();
    this.appData.tracks.subscribe((data) => {
      data.forEach(async (track) => {
        let stream = await track.streams.find((stream: any) => stream.id === streamId);
        if (stream) {
          this.track = track;
          this.stream = stream;
          console.log('STREAM', this.stream);


          this.streamNameFormControl.setValue(this.stream?.name);
          this.created = new Date(stream.dateCreated).toLocaleString('de-DE');
          if (stream.dateUpdated) this.updated = new Date(stream.dateUpdated).toLocaleString('de-DE');
          this.loadStreamPrompts();
        }
      });
    });

    this.appData.agents.subscribe((data) => {
      this.agents = data;
      this.defaultAgentId = this.agents.find((agent) => agent.isDefault === 1)?.id;
    });
  }

  async saveOutoutputControl() {
    let valid = true;

    for await (let control of this.outputControls) {
      if (control.control.valid === false || control.agentControl.valid === false) {
        valid = false;
        this.snack.error({   headline: "Error", text: "Please check all fields" });
        break;
      }
      if (control.promptTypeControl.value.trim() === 'STREAM_OUTPUT' || control.promptTypeControl.value.trim() === 'STREAM_PROMPT') {
        valid = false;
        this.snack.error({  headline: "Error", text: "STREAM_OUTPUT or STREAM_PROMPT is not a valid Name" });
        break;
      }
    }

    if (valid === false) {
      return;
    }
    let index = 0;
    this.hidespinner = false;
    for await (let control of this.outputControls) {

      let name: string = control.promptTypeControl.value;
      name = name.toUpperCase().replace(/ /g, '_');
      if (name.indexOf('OUTPUT_') === -1) {
        name = 'OUTPUT_' + name;
      }
      let updatePrompt: any = await this.promptService.savePrompt(
        control.id || null,
        this.stream.id,
        control.agentControl.value,
        name,
        index,
        JSON.stringify(control.control.value),
        control.creditControl.value,
        control.status.value,
        control.outputType.value
      );
      index++;

    }
    this.hidespinner = true;
  }
  outputControlUp(prompt: any) {
    let index = this.outputControls.findIndex((p) => p === prompt);
    if (index > 0) {
      moveItemInArray(this.outputControls, index, index - 1);
    }
  }
  outputControlDown(prompt: any) {
    let index = this.outputControls.findIndex((p) => p === prompt);
    if (index < this.outputControls.length - 1) {
      moveItemInArray(this.outputControls, index, index + 1);
    }
  }
  async addOutoutputControl() {
    let control = {
      orderNr: this.outputControls.length,
      target: this.stream.id,
      control: this.fb.control(''),
      agentControl: this.fb.control(this.defaultAgentId),
      creditControl: this.fb.control(0),
      version: 0,
      promptTypeControl: this.fb.control('STREAM_OUTPUT'),
      status: this.fb.control('INACTIVE'),
      outputType: this.fb.control('PDF'),
    }

    this.outputControls.push(control);
  }
  async setOtherVersion(value: number) {
    if (value === this.currentStreamPrompt.version) {
      this.streamRoleFormControl.setValue(JSON.parse(this.currentStreamPrompt.prompt).role);
      this.streamToneFormControl.setValue(JSON.parse(this.currentStreamPrompt.prompt).tone);
      this.streamContextFormControl.setValue(JSON.parse(this.currentStreamPrompt.prompt).context);
      return;
    }
    let prompt = await this.history.find((h) => h.version === value);
    if (prompt) {
      this.streamRoleFormControl.setValue(JSON.parse(prompt.prompt).role);
      this.streamToneFormControl.setValue(JSON.parse(prompt.prompt).tone);
      this.streamContextFormControl.setValue(JSON.parse(prompt.prompt).context);
    }
  }

  // SESSION HISTORY
  resetHistory() {
    this.sessionHistory = [];
    this.sessionHistoryIndex = 0;
  }
  async saveSessionHistory() {
    console.log(this.sessionHistoryIndex);

    // Check Changes
    if (this.sessionHistory.length > 0) {
      let last = this.sessionHistory[this.sessionHistory.length - 1];
      if (last.role === this.streamRoleFormControl.value && last.tone === this.streamToneFormControl.value && last.context === this.streamContextFormControl.value) {
        return;
      }
    }


    let prompt = {
      "role": this.streamRoleFormControl.value,
      "tone": this.streamToneFormControl.value,
      "context": this.streamContextFormControl.value
    };

    this.sessionHistory.push(prompt);
    this.sessionHistoryIndex = this.sessionHistory.length - 1;
    console.log(this.sessionHistory, this.sessionHistoryIndex);
  }
  sessionHistoryBack() {
    if (this.sessionHistoryIndex > 0) {
      this.sessionHistoryIndex--;
      this.streamRoleFormControl.setValue(this.sessionHistory[this.sessionHistoryIndex].role);
      this.streamToneFormControl.setValue(this.sessionHistory[this.sessionHistoryIndex].tone);
      this.streamContextFormControl.setValue(this.sessionHistory[this.sessionHistoryIndex].context);
    }
  }
  sessionHistoryForward() {
    if (this.sessionHistoryIndex < this.sessionHistory.length - 1) {
      this.sessionHistoryIndex++;
      this.streamRoleFormControl.setValue(this.sessionHistory[this.sessionHistoryIndex].role);
      this.streamToneFormControl.setValue(this.sessionHistory[this.sessionHistoryIndex].tone);
      this.streamContextFormControl.setValue(this.sessionHistory[this.sessionHistoryIndex].context);
    }
  }
  // END SESSION HISTORY

  async deleteStreamPrompt(id: string) {
    this.hidespinner = false;
    let result = await this.promptService.deletePromptById(id);
    this.hidespinner = true;
    if (result !== false) {
      this.outputControls = this.outputControls.filter((control) => control.id !== id);
    }
  }

  async loadStreamPrompts() {
    this.resetHistory();
    let prompts: any = await this.promptService.getPromptsByTargetId(this.stream?.id);
    if (prompts === false || prompts.length === 0) return;
    let streamPrompt = await prompts.filter((prompt: any) => prompt.promptType === "STREAM_PROMPT")[0];
    let outputPrompt = await prompts.filter((prompt: any) => prompt.promptType !== "STREAM_PROMPT");

    // Order outputPrompts by orderNr
    outputPrompt = outputPrompt.sort((a: any, b: any) => {
      if (a.orderNr < b.orderNr) {
        return -1;
      }
      if (a.orderNr > b.orderNr) {
        return 1;
      }
      return 0;
    });

    this.outputControls = [];

    for await (let prompt of outputPrompt) {
      let promptString = ""
      try {
        promptString = JSON.parse(prompt.prompt)
      } catch (error: any) {
        promptString = prompt.prompt
      }

      let control = {
        orderNr: prompt.orderNr,
        target: prompt.target,
        creditControl: this.fb.control(prompt.creditCosts || 0),
        control: this.fb.control(promptString),
        agentControl: this.fb.control(prompt.agentId),
        version: prompt.version,
        promptType: prompt.promptType,
        promptTypeControl: this.fb.control(prompt.promptType),
        id: prompt.id,
        creditCosts: prompt.creditCosts,
        status: this.fb.control(prompt.status),
        outputType: this.fb.control(prompt.outputType),
      }
      this.outputControls.push(control);
    }

    this.streamPromptVersions = [];

    if (!streamPrompt) return;

    this.streameVersionFormControl.setValue(streamPrompt?.version);

    this.currentStreamPrompt = streamPrompt;

    let name = `v: ${streamPrompt?.version} | CURRENT`;
    this.streamPromptVersions.push({ id: streamPrompt?.version, name: name });

    this.sessionHistory.push(JSON.parse(streamPrompt?.prompt));

    this.streamRoleFormControl.setValue(JSON.parse(streamPrompt?.prompt).role);
    this.streamToneFormControl.setValue(JSON.parse(streamPrompt?.prompt).tone);
    this.streamContextFormControl.setValue(JSON.parse(streamPrompt?.prompt).context);

    let result: any = await this.promptService.getHistoryDataByPromptId(this.currentStreamPrompt?.id);
    if (result !== false) {
      this.history = result;
      for (let h of result) {
        let name = `v: ${h.version} | ${new Date(h.dateCreated).toLocaleString('de-DE')}`;
        this.streamPromptVersions.push({ id: h.version, name: name });
      }
      this.streameVersionFormControl.valueChanges.subscribe(async (value: any) => {
        this.setOtherVersion(value);
      });

    }

  }

  async editStep(step: any) {
    let dia = await this.dialog.open(EditStepComponent, {
      data: step
    });

    dia.afterClosed().subscribe(async (result) => {
      if (result) {
        this.appData.loadAllTracks();
      }
    });
  }

  async addStep() {
    let step = {
      streamId: this.stream.id,
      orderNr: this.stream.steps.length + 1,
      creditCosts: 0,
      stepTypeId: "UNSET"
    }
    this.hidespinner = false;
    let result: any = this.streamService.addStreamStep(step.streamId, step.stepTypeId, step.creditCosts, step.orderNr);
    if (result !== false) await this.appData.loadAllTracks();
    this.hidespinner = true;
  }
  async dropStep(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.stream.steps, event.previousIndex, event.currentIndex);
    // ToDo: Update all orderNr in DB
  }
  async deleteStep(step: any) {
    this.hidespinner = false;
    let result: any = this.streamService.deleteStreamStep(step.id);
    if (result !== false) await this.appData.loadAllTracks();
    this.hidespinner = true;
  }

  async saveStreamSettings() {
    // console.log(this.streamRoleFormControl.value);
    // console.log(this.streamToneFormControl.value);
    // console.log(this.streamContextFormControl.value);
    let streamPrompt = {
      "role": this.streamRoleFormControl.value,
      "tone": this.streamToneFormControl.value,
      "context": this.streamContextFormControl.value
    };

    // console.log(this.currentStreamPrompt);
    // return

    this.hidespinner = false;
    let updatePrompt: any = await this.promptService.savePrompt(
      this.currentStreamPrompt?.id || null,
      this.stream.id,
      this.defaultAgentId,
      "STREAM_PROMPT",
      0,
      JSON.stringify(streamPrompt),
      0,
      null,
      null
    );
    this.hidespinner = true;

    let updateName: any = await this.streamService.updateStream(
      this.track.id,
      this.stream.id,
      this.streamNameFormControl.value,
      this.stream.description,
      this.stream.orderNr
    );

    if (updateName !== false && updatePrompt !== false) {
      this.snack.success(updateName.msg);
      await this.appData.loadAllTracks();
    }


  }
}
